// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"41":"ff8e7d35","94":"da5585d7","126":"8f4c421e","302":"fbc1e1ef","341":"c6cead73","565":"20a3e0f3"}[chunkId] + ".css";
};